<agr-wrapper-site-sidenav [navigationItems]="navigationItems" data-test="site-root">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
<app-manure-space-customer-selection-custom-config></app-manure-space-customer-selection-custom-config>
